import Vue from 'vue'
import App from './App.vue'
import { Field,  RadioGroup, Radio,Form, Button, Icon, Dialog, Toast } from 'vant';
Vue.use(Field);
Vue.use(Radio);
Vue.use(Button);
Vue.use(Form);
Vue.use(Icon);
Vue.use(RadioGroup);
Vue.use(Dialog);
Vue.use(Toast);
Vue.config.productionTip = false
new Vue({
  render: h => h(App),
}).$mount('#app')
